<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>
            Change Password
          </h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    :type="'password'"
                    v-model="oldPassword"
                    name="oldPassword"
                    label="Old Password"
                    v-validate="{required : true}"
                    data-vv-as="Old Password"
                    :error-messages="errors.collect('oldPassword')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    :type="'password'"
                    v-model="newPassword"
                    name="newPassword"
                    label="New Password"
                    v-validate="{required : true , verify_password : true}"
                    data-vv-as="New Password" ref="newPassword"
                    :error-messages="errors.collect('newPassword')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    :type="'password'"
                    v-model="confirmNewPassword"
                    name="confirmNewPassword"
                    label="Confirm Password"
                    v-validate="'required|confirmed:newPassword'"
                    data-vv-as="Confirm Password"
                    :error-messages="errors.collect('confirmNewPassword')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import commonservice from "../../shared/common.service"
import store from "../../store";
export default {
  computed: {
    oldPassword: {
      get() {
        return this.$store.state.changepassword.oldPassword;
      },
      set(val) {
        this.$store.commit("changepassword/SET_CHANGEPASSWORD_DATA", {
          key: "oldPassword",
          value: val
        });
      }
    },
    newPassword: {
      get() {
        return this.$store.state.changepassword.newPassword;
      },
      set(val) {
        this.$store.commit("changepassword/SET_CHANGEPASSWORD_DATA", {
          key: "newPassword",
          value: val
        });
      }
    },
    confirmNewPassword: {
      get() {
        return this.$store.state.changepassword.confirmNewPassword;
      },
      set(val) {
        this.$store.commit("changepassword/SET_CHANGEPASSWORD_DATA", {
          key: "confirmNewPassword",
          value: val
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(p=>{
        p.reset()
      });
  },
  methods: {
    submit() {
      if (this.$store.state.base.loader) return;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch("changepassword/save").then(
            () => {
              commonservice.showSuccessMessage("Password changed successfully");
              this.reset();
            }
          );
        }
      });
    },
    reset() {
      this.$store.commit("changepassword/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    }
  }
};
</script>
